import { useNavigate } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';
import { ChevronRight, Calendar, ArrowLeft } from 'lucide-react';
import { useTranslations } from '../i18n';

export function BlogList() {
  const navigate = useNavigate();
  const { language, t } = useTranslations();

  return (
    <div className="min-h-screen bg-gradient-theme p-4 sm:p-8">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors mb-8 font-bold"
        >
          <ArrowLeft size={20} />
          {t.common.back}
        </button>

        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 dark:text-white mb-10 tracking-tight">
          {t.blog.resourceCenter}
        </h1>

        <div className="grid gap-8">
          {blogPosts.map((post) => (
            <div
              key={post.id}
              onClick={() => navigate(`/blog/${post.slug}`)}
              className="group cursor-pointer bg-white dark:bg-slate-900 rounded-[2.5rem] border border-slate-200 dark:border-slate-800 p-6 sm:p-8 hover:shadow-2xl transition-all duration-500 flex flex-col sm:flex-row gap-8 items-center"
            >
              <div className="w-full sm:w-48 h-48 rounded-3xl overflow-hidden bg-slate-100 dark:bg-slate-800 flex-shrink-0">
                <div className="w-full h-full bg-gradient-to-br from-blue-500/20 to-purple-600/20 flex items-center justify-center text-blue-500">
                  {/* Fallback if no image */}
                  <span className="text-4xl font-black">{post.title[0]}</span>
                </div>
              </div>

              <div className="flex-1 space-y-4">
                <div className="flex items-center gap-4 text-sm font-bold text-slate-500 dark:text-slate-500">
                  <span className="flex items-center gap-1.5">
                    <Calendar size={16} />
                    {new Date(post.date).toLocaleDateString(language === 'lv' ? 'lv-LV' : 'en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </span>
                </div>

                <h2 className="text-xl sm:text-2xl font-black text-slate-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors leading-tight">
                  {post.title}
                </h2>

                <p className="text-lg text-slate-600 dark:text-slate-400 leading-relaxed line-clamp-2 font-medium">
                  {post.excerpt}
                </p>

                <div className="flex items-center gap-2 text-blue-600 dark:text-blue-400 font-black text-lg group-hover:gap-4 transition-all pt-2">
                  {t.blog.readMore}
                  <ChevronRight size={20} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
